<template>
    <div class="login-tool">
      <el-tabs v-model="loginType" @tab-click="activeTab">
        <el-tab-pane label="密码登录" name="passwordLogin">
          <el-form :model="userInfo1" :size="'small'" :rules="userInfoRules" ref="userInfo1" style="height: 110px">
            <el-form-item label="" prop="userName" v-if="!codeForLogin">
              <el-input v-model="userInfo1.userName" prefix-icon="el-icon-user" placeholder="用户名、手机号或邮箱"
                        clearable></el-input>
            </el-form-item>
            <el-form-item label="" prop="password" v-if="!codeForLogin">
              <el-input v-model="userInfo1.password" prefix-icon="el-icon-key" placeholder="输入密码" @keyup.enter.native="submitForLogin()"
                        show-password></el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="验证码登录" name="codeLogin">
          <el-form :model="userInfo2" :size="'small'" :rules="userInfoRules" ref="userInfo2" style="height: 110px">
            <el-form-item label="" prop="phone_email">
              <el-input v-model="userInfo2.phone_email" ref="phone_email" prefix-icon="el-icon-user"
                        placeholder="手机号或邮箱" clearable></el-input>
            </el-form-item>
            <el-form-item label="" prop="loginVerificationCode">
              <el-input ref="loginVerificationCode" v-model="userInfo2.loginVerificationCode"
                        class="login-verification-code"
                        prefix-icon="el-icon-message" @keyup.enter.native="submitForLogin()" placeholder="验证码">
                <el-button v-if="verificationCodeFlag" slot="append" @click="checkPhoneNumberAddSendMsg">发送验证码
                </el-button>
                <div v-else slot="append" class="login-waiting-code">已发送 {{waitingCodeTime}} s</div>
              </el-input>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <el-button type="primary" :size="'small'" @click="submitForLogin()" style="width: 100%;margin-top: 5px">登录</el-button>
    </div>
</template>

<script>
export default {
  name: 'LoginTool',
  data () {
    // 手机号或邮箱校验
    let validatePhoneOrEmail = (rule, value, callback) => {
      if (!(/^1[3456789]\d{9}$/.test(value.trim())) &&
        !(new RegExp('^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$').test(value.trim()))) {
        callback(new Error('请输入正确的手机号码或邮箱'))
      }
      callback()
    }
    // 验证码校验
    let validateVerificationCode = (rule, value, callback) => {
      if (!(/^\d{6}$/.test(value.trim()))) {
        callback(new Error('请输入6位正确的验证码'))
      }
      callback()
    }
    // 用户名校验 /^[a-zA-Z0-9_-]{4,20}$/ 用户名由英文字母，数字及下划线组成，长度4-20位
    // let validateUserName = (rule, value, callback) => {
    //   if (!(/^[a-zA-Z0-9_-]{4,20}$/.test(value.trim()))) {
    //     callback(new Error('用户名由英文字母，数字及下划线组成，长度4-20位'))
    //   }
    //   callback()
    // }
    // 密码正则校验
    let validatePass = (rule, value, callback) => {
      if (!/^[\w_-]{6,20}$/.test(value.trim())) {
        callback(new Error('请输入6-20位字母、数字或特殊字符(-_)作为密码'))
      }
      callback()
    }
    return {
      userInfoRules: {
        phone_email: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        number: [
          {required: true, message: '请输入手机号或邮箱', trigger: 'blur'},
          {validator: validatePhoneOrEmail, trigger: 'blur'}
        ],
        userName: [
          {required: true, message: '输入用户名、手机号或邮箱', trigger: 'blur'}
          // {validator: validateUserName, trigger: 'blur'}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'}
        ],
        loginVerificationCode: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ],
        code: [
          {required: true, message: '请输入验证码', trigger: 'blur'},
          {validator: validateVerificationCode, trigger: 'blur'}
        ]
      },
      loginType: 'passwordLogin',
      userInfo1: {
        userName: '',
        password: ''
      },
      userInfo2: {
        phone_email: '',
        loginVerificationCode: ''
      },
      verificationCodeFlag: true,
      waitingCodeTime: 60,
      codeForLogin: false
    }
  },
  methods: {
    activeTab (tab, event) {
      if (this.loginType === 'passwordLogin') {
        this.$refs['userInfo2'].resetFields()
      } else {
        this.$refs['userInfo1'].resetFields()
      }
    },
    checkPhoneNumberAddSendMsg () {
      // let form = this.isResetPassword ? 'userInfo3' : 'userInfo2'
      // let number = this.isResetPassword ? 'number' : 'phone_email'
      this.$refs['userInfo2'].validateField('phone_email', (errMsg) => {
        if (!errMsg) {
          this.verificationCodeFlag = false
          if (this.isResetPassword) {
            this.$refs.code.focus()
          } else {
            this.$refs.loginVerificationCode.focus()
          }
          let timer = setInterval(() => {
            this.waitingCodeTime--
            if (this.waitingCodeTime === 0) {
              this.waitingCodeTime = 60
              clearInterval(timer)
              this.verificationCodeFlag = true
            }
          }, 1000)
          // 调接口发送验证码
          let param = {number: ''}
          param.number = this.userInfo2.phone_email
          this.$http.get(this.$api.getVerificationCode.url, param).then(res => {
            console.log(res)
          })
        } else {
          if (this.isResetPassword) {
            this.$refs.number.focus()
          } else {
            this.$refs.phone_email.focus()
          }
        }
      })
    },
    submitForLogin () {
      if (this.loginType === 'passwordLogin') {
        this.$refs['userInfo1'].validate((valid) => {
          if (valid) {
            this.$http.post(this.$api.loginUser.url, this.userInfo1).then(res => {
              if (res && res.code === 200) {
                this.$cookies.set('user_session', res.data['entryCode'], '15d')
                this.$store.set('Authorization', res.data['entryCode'])
                this.$store.session.set('Authorization', res.data['entryCode'])
                this.$store.set('user', res.data)
                this.$store.session.set('user', res.data)
                // 刷新当前页面
                this.$router.go(0)
              } else if (res.msg) {
                this.$message.warning(res.msg)
              }
            })
          } else {
            return false
          }
        })
      } else {
        this.$refs['userInfo2'].validate((valid) => {
          if (valid) {
            this.$http.post(this.$api.loginUser.url, {
              number: this.userInfo2.phone_email,
              code: this.userInfo2.loginVerificationCode
            }).then(res => {
              if (res && res.code === 200) {
                this.$cookies.set('user_session', res.data['entryCode'], '7d')
                this.$store.set('Authorization', res.data['entryCode'])
                this.$store.session.set('Authorization', res.data['entryCode'])
                this.$store.set('user', res.data)
                this.$store.session.set('user', res.data)
                // 刷新当前页面
                this.$router.go(0)
              } else if (res.msg) {
                this.$message.warning(res.msg)
              }
            })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>

<style scoped>
  .login-tool {
    position: fixed;
    top: 195px;
    right: calc(50% - 860px);
    background: #ffffff;
    width: 220px;
    height: 210px;
    border-radius: 2px;
    text-align: left;
    padding: 10px;
  }
  /deep/ .el-tabs__nav {
    width: 100%;
    text-align: center;
  }

  /deep/ .el-tabs__item {
    width: 50%;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginTool/LoginTool.vue